/**
 * 下载按钮
 */
import React from 'react';
import { observer } from 'mobx-react-lite';
import appLogger from '@public/log/monitor';
import { Flex, SVGPureIcon } from '@/ui';
import client from '@/store/client';
import Tooltip from "@/ui/tooltip"

const DownloadBtn = observer(({ className = '', small = false }) => {
  if (client.isClient || client.isLLQ || client.isSeLLQ) return null;
  return (
    <Tooltip title={small ? "下载纳米客户端" : ""}>
      <Flex
        center
        className={[
          'h-32px cursor-pointer rounded-full bg-black pl-12px pr-14px hover:bg-[#333333] z-10',
          small ? "!px-7px" : "",
          className,
        ]}
        onClick={evt => {
          appLogger.log({
            key: 'aibot_home',
            action: 'click',
            arrt: 'download_button',
          });
          window.open('https://bot.n.cn/download?src=xz_bot_host');
        }}
      >
        <SVGPureIcon name="client_download" className="size-18px text-white" />
        {
          !small
          ? (
            <span className="text-14px ml-6px text-white">下载纳米客户端</span>
          )
          : null
        }
      </Flex>
    </Tooltip>
  );
});
export default DownloadBtn;
